/* eslint-disable max-len */
import { AuthUser, LoggedInState } from 'types/auth';
import { RootState } from 'store/index';

export const selectUser = (state: RootState): AuthUser | null => state.auth.user;

export const selectLoginState = (state: RootState): LoggedInState => state.auth.loggedInState;

export const selectIsSuperAdmin = (state: RootState): boolean | null => (state.auth.user ? state.auth.user.isSuperAdmin : false);
